import PropTypes from 'prop-types';
import { DisplayGridRecordPropType } from './display-grid-record';

export const DisplayGridGroupByRowMetadata = PropTypes.shape({
  groupById: PropTypes.string,
  groupByDetails: PropTypes.array,
  isGroupbySeparator: PropTypes.bool,
});

export const DisplayGridGroupRecordPropType = PropTypes.arrayOf(
  PropTypes.oneOfType([DisplayGridRecordPropType, DisplayGridGroupByRowMetadata]),
);
